import isEqual from 'lodash/isEqual';
import { CountUp } from 'countup.js';

class Configurator {
    constructor() {
        this.$el = $('.configurator');
        // this.langLocal = JSON.parse(localStorage.getItem('lang-local')) || JSON.parse($('#configurator-lang', this.$el).text()).lang;

        this.ui = {
            $paymentSwitchInput: $('.configurator__payment-switch input', this.$el),
            $cpmValue: $('.configurator__display-place_cpm .configurator__display-value', this.$el),
            $cpmValue2: $('.configurator__display__mobile-place .configurator__display__mobile-value', this.$el),
            $ppcValue: $('.configurator__display-place_price .configurator__display-value', this.$el),
            $resultValue: $('.configurator__display-place_result .configurator__display-value', this.$el),
            $cpmInput: $('.configurator__cpm-input', this.$el),
            $optionsContainer: $('.configurator__options', this.$el),
            $options: $('.configurator__option', this.$el),
            $optionInputs: $('.configurator__option input[name]', this.$el),
            $optionInputs2: $('.configurator__option__mobile', this.$el),
            $optionContainer2: $('.configurator__payment-switch .pricing-switch .custom-control .custom-switch', this.$el),
            $customSlidePin: $('.configurator__range__slider-pin', this.$el),
            $grayLine: $('.configurator__range__gray-line', this.$el),
            $blueLine: $('.configurator__range__blue-line', this.$el),
            $rangeContainer: $('.configurator__range__container', this.$el),
            $start: $('.configurator__range__vertical-green-line__start', this.$el),
            $middle: $('.configurator__range__vertical-green-line__middle', this.$el),
        };

        this.dataAll = null;
        this.data = null;
        this.lang = localStorage.getItem('lang-local') === 'ru' | $('html')[0].lang.split('-')[0] === 'ru'  ? 'ru' : 'eu';
        this.state = {
            section_1_end: 300,
            section_2_end: 1000,
            section_1_step: 30,
            section_2_step: 50,
            drag: false,
            step: 0,
            dragX: 0,
            offsetX: 0,
            suffixPrice: ' ₽',
            lastStep: '>1000'
        };
        this.initCountUps();

        this.updateState();

        this.initRangeSlider();
        document.querySelector('.configurator__range__container').addEventListener('mousedown', this.MouseDown.bind(this))
        document.querySelector('.configurator__range__container').addEventListener('touchstart', this.MouseDown.bind(this))
        document.querySelector('.configurator__display--money--value-container').addEventListener('click', this.OnClickMoney.bind(this))
        document.querySelectorAll('.configurator__display--money--option').forEach((el) => el.addEventListener('click', this.OnChangeMoney.bind(this)))
        document.addEventListener('mousemove', this.MouseMove.bind(this))
        document.addEventListener('touchmove', this.MouseMove.bind(this))
        document.addEventListener('mouseup', this.MouseUp.bind(this))
        document.addEventListener('touchend', this.MouseUp.bind(this))
        document.addEventListener('keydown', this.onKeyPress.bind(this))
        // document.addEventListener('click', this.ClickOutside.bind(this))

        this.ui.$paymentSwitchInput
            .add(this.ui.$cpmInput)
            .add(this.ui.$optionInputs)
            .on('change', this.updateState.bind(this));
    }

    // ClickOutside(e){
    //     if(e.target.className !== 'configurator__display--money') {
    //         document.querySelector('.configurator__display--money--select').style.display = 'none';
    //     }
    // }

    // Update START ----------------------------------------------------
    // Update END   ----------------------------------------------------
    ValidateСurrency(money){
        if(money === '€') return 'eu'
        if(money === '$') return 'en'
        return 'ru'
    }

    LocaleToСurrency(){
        const locale = JSON.parse(localStorage.getItem('lang-local'))
        if(locale !== 'ru') {
            this.lang = 'eu'
        }
        this.lang = 'ru'
    }

    OnChangeMoney(e){
        const value = e.target.innerText
        const name = this.ValidateСurrency(value)
        document.querySelector('.configurator__display--money--value').innerHTML = value;
        document.querySelector('.configurator__display--text-money').innerHTML = value;
        document.querySelector('.configurator__display--money--select').style.display = 'none';
        this.lang = name
        this.updateState()
    }

    OnClickMoney(){
        if(document.querySelector('.configurator__display--money--select').style.display === 'flex'){
            document.querySelector('.configurator__display--money--select').style.display = 'none';
        }else{
            document.querySelector('.configurator__display--money--select').style.display = 'flex';
        }
    }
    // actions start ---------------------------------------------------
    // KeyBoard
    onKeyPress ({ key }) {
        if(key === 'ArrowRight' || key === 'ArrowUp' || key === 'w' || key === 'd'){
            if(this.state.step <= this.state.customers.length - 2){
                this.updateKeyPress(this.state.step + 1)
            }
        }

        if(key === 'ArrowLeft' || key === 'ArrowDown' || key === 's' || key === 'a'){
            if(this.state.step >= 1){
                this.updateKeyPress(this.state.step - 1)
            }
        }
    };
    //
    // update state then key press
    updateKeyPress(step){
        this.state.step = step
        const line = document.querySelector('.configurator__range__gray-line')
        let newStep = line.clientWidth * (this.state.customers[step].dist/100)
        this.getWereAmI(newStep)
        this.updatePinPx(newStep)
    }
    // MouseDown //
    MouseDown(e){
        e.preventDefault();
        let offsetX
        const con = document.querySelector('.configurator__range__container');
        if (e.type === "touchstart") {
            offsetX = e.touches[0].clientX;
        } else {
            offsetX = e.pageX || e.clientX + con.clientWidth;
        }

        let posX = offsetX - $(con).offset().left
        this.getWereAmI(posX)
        this.updatePinPx(posX)
        this.state.offsetX = posX
        this.state.drag = true
    }
    //
    // MouseMove //
    MouseMove(e){
        e.preventDefault();
        let offsetX, currentX
        const con = document.querySelector('.configurator__range__container');

        if (this.state.drag) {
            if (e.type === "touchmove") {
                offsetX = e.touches[0].pageX;

            } else {
                offsetX = e.pageX || e.clientX + con.clientWidth;
            }

            currentX = offsetX - $(con).offset().left

            this.getWereAmI(currentX)
            this.updatePinPx(currentX)
            this.state.offsetX = currentX
        }

    }
    //
    // MouseUp //
    MouseUp(e){
        // e.preventDefault();
        const pin = document.querySelector('.configurator__range__slider-pin')
        this.state.drag = false
        pin.removeEventListener('mousemove', this.MouseMove)
        pin.removeEventListener('mousedown', this.MouseDown)
    }
    //
    // actions end -----------------------------------------------------
    //
    // find were client click start ------------------------------------
    //
    getClosest(wereAmI){
        const {customers} = this.state
        const pin = document.querySelector('.configurator__range__slider-pin')
        const grayLine = document.querySelector('.configurator__range__gray-line')
        const pinP = (pin.clientWidth  / grayLine.clientWidth) * 100
        return customers.reduce(function(prev, curr) {
            return (prev.dist < wereAmI - pinP ? curr : prev);
        });
    }
    //
    helperUpdateState(step){
        if(this.state.customers[step].customer !== '>1000'){
            this.state.cpm = this.state.customers[step].customer
        }else{
            this.state.cpm = this.state.customers[step - 1].customer
        }

        this.state = {...this.state, ...this.calcState(this.state)}
        this.render()
    }
    //
    getWereAmI(clientX){
        const line = document.querySelector('.configurator__range__gray-line')
        this.state.offsetX = clientX
        const wereAmI = (clientX / line.offsetWidth) * 100
        const closest = this.getClosest(wereAmI);
        const step  = this.state.customers.indexOf(closest)
        this.state.step = step
        this.updateLabelActive('start', this.state.section_1_end)
        this.updateLabelActive('middle', this.state.section_2_end)
        this.helperUpdateState(step)
    }
    //
    // find were client click end ------------------------------------

    //
    updateLabelActive(name, step){
        const container = `.configurator__range__vertical-green-line__${name}`
        const label = `.configurator__range__vertical-green-line__${name} label`
        const div = `.configurator__range__vertical-green-line__${name} div`
        if(this.state.step  > this.state.rawCustomers.indexOf(step) - 1){
            $(label).css('color', '#2788fb' )
            $(label).css('font-size', '1.2em' )
            $(div).css('background-color', '#2788fb' )
            $(container).css('background-color', '#2788fb' )
        }else{
            $(label).css('color', '#59cd90' )
            $(label).css('font-size', '1.1em' )
            $(div).css('background-color', '#59cd90' )
            $(container).css('background-color', '#59cd90' )
        }
    }

    calcPricingItem(state, name, basePrice, minPrice){
        let value;
        if (basePrice > minPrice) {
            state[name] = true;
            state[name + '_readonly'] = true;
        }else if (state[name]) {
            state[name + '_readonly'] = false;
            value =  this.data[name + '_price'];
        }

        return value !== undefined ? value : 0;
    }

    calcState(state) {
        state = Object.assign({}, state);
        let basePrice = this.data.cpm_prices[state.cpm];
        let totalPrice = basePrice;

        totalPrice += this.calcPricingItem(state, 'mailing', basePrice,48000);
        totalPrice += this.calcPricingItem(state, 'phone', basePrice, 48000);
        totalPrice += this.calcPricingItem(state, 'client_accounts', basePrice,48000);
        totalPrice += this.calcPricingItem(state, 'branch', basePrice, 98000);

        state.ppc = (state.annual ? totalPrice * (this.data.annual_factor) : totalPrice) / state.cpm;
        state.total_price = state.cpm * state.ppc;

        return state;
    }

    initCountUps() {
        this.countUps = {};
        this.countUps.cpm = new CountUp(this.ui.$cpmValue[0], 0, {
            duration: .5,
            separator: ' ',
        });

        this.countUps.cpm2 = new CountUp(this.ui.$cpmValue2[0], 0, {
            duration: .5,
            separator: ' ',
        });

        this.countUps.ppc = new CountUp(this.ui.$ppcValue[0], 0, {
            decimalPlaces: 2,
            duration: .5,
            separator: ' ',
            decimal: ',',
            // suffix: suffixPrice,
        });

        this.countUps.result = new CountUp(this.ui.$resultValue[0], 0, {
            duration: .5,
            separator: ' ',
            // suffix: suffixPrice,
        });
    }
    //
    initRangeSlider() {
        this.ui.$start.css ('left', `${this.state.section_1_step}%`);
        this.ui.$middle.css ('left', `${this.state.section_1_step + this.state.section_2_step}%`);
        this.ui.$blueLine.css('transform', `scaleX(${this.state.customers[0].dist / 100})`);
    }

    render() {

        if(this.state.customers[this.state.step].customer !== this.state.lastStep) {
            document.querySelector('.configurator__display__container').style.display = 'flex'
            this.countUps.cpm.update(this.state.cpm);
            this.countUps.cpm2.update(this.state.cpm);
            this.countUps.ppc.update(this.state.ppc);
            this.countUps.result.update(this.state.total_price);
            document.querySelector('.configurator__cpm-input').value = this.state.cpm
            document.querySelector('.configurator__display--text').style.display = 'none'

            this.ui.$optionInputs.each((_, input) => {
                const $input = $(input);
                const key = $input.data('name');
                const mobileSwitch = $('label[for=form-' + key + ']')

                mobileSwitch.toggleClass('active', this.state[key]).toggleClass('readonly', this.state[key + '_readonly']);
                mobileSwitch.parent().toggleClass('readonly', this.state[key + '_readonly']);
                $input.prop('checked', this.state[key]);
                $input.prop('disabled', this.state[key + '_readonly'])
                    .parent()
                    .toggleClass('active', this.state[key])
                    .toggleClass('readonly', this.state[key + '_readonly']);
            });
        }else{
            document.querySelector('.configurator__display__container').style.display = 'none'
            document.querySelector('.configurator__display--text').style.display = 'block'
        }
    }

    ArrayCustomers(customers){
        const newCustomers =  Object.entries(customers)
        customers = newCustomers.map(([key, value]) => parseInt(key))
        customers = customers.filter((item) => item < 1200)
        return customers
    }

    SplitCustomers(customers){
        const section_1 = customers.slice(0, customers.indexOf(this.state.section_1_end) + 1)
        const section_2 = customers.slice(customers.indexOf(this.state.section_1_end) + 1)
        return { section_1, section_2 }
    }

    generateNewArray (customers, step, baseStep = 0) {
        let newSection = [];
        for(let i = 1; i <= customers.length; i++){
            newSection.push({dist: (i * step) + baseStep, customer: customers[i-1]})
        }

        return newSection
    }

    OffsetCustomers(customers){
        const { section_1, section_2 } = customers
        const fullWidth = 100;

        const stepSection_1 = this.state.section_1_step / section_1.length
        const stepSection_2 = this.state.section_2_step / section_2.length

        let newSection_1 = this.generateNewArray(section_1, stepSection_1, 0);
        let newSection_2 = this.generateNewArray(section_2, stepSection_2, this.state.section_1_step);
        const lastStep = newSection_2[newSection_2.length - 1].customer
        this.state.lastStep = `>${lastStep}`
        let newSection_3 = [{ dist: fullWidth, customer: `>${lastStep}` }];
        return { newSection_1, newSection_2, newSection_3}
    }

    generateArray(){
        this.dataAll = JSON.parse($('#configurator-data', this.$el).text())[0];
        this.data = this.dataAll[this.lang];
        const rawCustomers = this.data.cpm_prices;

        const arrayCustomers = this.ArrayCustomers(rawCustomers)
        const splitCustomers = this.SplitCustomers(arrayCustomers)
        const offsetCustomers = this.OffsetCustomers(splitCustomers)
        const allCustomers = [...offsetCustomers.newSection_1, ...offsetCustomers.newSection_2, ...offsetCustomers.newSection_3]
        return { customers: allCustomers, rawCustomers: arrayCustomers }
    }

    updatePinPx(x){
        const pin = document.querySelector('.configurator__range__slider-pin');
        const grayLine = document.querySelector('.configurator__range__gray-line');
        const blueLine = document.querySelector('.configurator__range__blue-line');

        let offset = (x / grayLine.clientWidth) * 100
        let transform = x / grayLine.clientWidth

        if(this.state.customers[0].dist < offset < 100 ){
            pin.style.left = `${offset}%`;
            blueLine.style.transform = `scaleX(${transform})`;
        }

        if(this.state.customers[0].dist > offset){
            pin.style.left = `${this.state.customers[0].dist}%`;
            blueLine.style.transform = `scaleX(${this.state.customers[0].dist / 100})`;
        }

        if(100 < offset){
            pin.style.left = `${100}%`;
            blueLine.style.transform = `scaleX(${1})`;
        }
    }

    updateState() {

        const { customers, rawCustomers } = this.generateArray();

        var state = {
            annual: this.ui.$paymentSwitchInput.prop('checked'),
            cpm: parseInt(this.ui.$cpmInput.val(), 10),
            customers,
            rawCustomers,
        };

        this.ui.$optionInputs.each((_, input) => {
            const $input = $(input);
            const key = $input.data('name');

            state[key] = $input.prop('checked');
            state[key + '_readonly'] = $input.parent().hasClass('readonly');
        });

        state = this.calcState(state);


        if (!isEqual(this.state, state)) {
            this.state = {...this.state, ...state};
            this.render();
        }
    }
}

export default Configurator;
